module.exports = __webpack_public_path__ + "static/media/desktop.15478b34.ini";